const PLACEHOLDER_VALUES = new Set(["none", "n/a", "na"]);

export const blankIfPlaceholder = (value) => {
  if (typeof value !== "string") return value;
  const trimmed = value.trim();
  if (!trimmed || PLACEHOLDER_VALUES.has(trimmed.toLowerCase())) return "";
  return value;
};
